import { CSSObject } from '@emotion/react';
import { CSSProperties } from 'react';
import { AccordionBorder, useHoneycombTheme } from '../../theming';

const getBorderWidth = (border: AccordionBorder): CSSProperties['borderWidth'] => {
    if (border === 'both') {
        return '1px 0';
    }
    if (border === 'top') {
        return '1px 0 0 0';
    }
    if (border === 'bottom') {
        return '0 0 1px 0';
    }
    return '0';
};

type StyleClasses = 'root';
export interface AccordionStylesParams {
    border: AccordionBorder;
}

export function useStyles({ border }: AccordionStylesParams): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const { theme } = useHoneycombTheme();

    const root: CSSObject = {
        borderStyle: 'solid',
        borderColor: theme.palette.border,
        borderWidth: getBorderWidth(border),
    };

    return {
        styles: {
            root,
        },
    };
}
